/**
 * Returns the lowest element in the tree that contains every given element,
 * walking up from the first node until `upToRoot` is reached.
 */
export function getCommonAncestorOfElements(
  elements: HTMLElement[],
  upToRoot: HTMLElement
): HTMLElement {
  if (elements.length === 0) return upToRoot;
  let node: Node | null = elements[0];
  while (node && node !== upToRoot.parentNode) {
    if (node instanceof HTMLElement) {
      const el = node;
      if (elements.every((e) => el.contains(e))) {
        return el;
      }
    }
    node = node.parentNode;
  }
  return upToRoot;
}
